import { render, staticRenderFns } from "./ReplyMessage.vue?vue&type=template&id=45f82f83"
import script from "./ReplyMessage.vue?vue&type=script&lang=js"
export * from "./ReplyMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports